module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list d-flex h-100 flex-column align-items-center px-3"
  }, [(!_vm.getSlimFilters || _vm.getIsLoadingEvents) ? _c('div', {
    staticClass: "text-center p-4"
  }, [_c('loader')], 1) : _c('div', {
    staticClass: "d-flex flex-column w-100 h-100 pt-4"
  }, [_c('div', {
    staticClass: "w-100 flex-grow-1 overflow-auto"
  }, [_c('product-filter', {
    attrs: {
      "products": _vm.getProductsShowingOnCalendar
    },
    on: {
      "change": function($event) {
        return _vm.updateFilters()
      },
      "loaded": function($event) {
        return _vm.updateFilters()
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "mb-4 border-top-light mt-2"
  }, [_c('div', {
    staticClass: "w-100"
  }, [_c('label', [_vm._v("Resource:")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "searchable": true,
      "options": _vm.resources,
      "multiple": true,
      "taggable": false,
      "track-by": "id",
      "label": "name",
      "selectLabel": "",
      "deselectLabel": "",
      "placeholder": "All Resources",
      "open-direction": "top"
    },
    on: {
      "input": _vm.updateFilters,
      "remove": _vm.updateFilters
    },
    model: {
      value: (_vm.selectedResource),
      callback: function($$v) {
        _vm.selectedResource = $$v
      },
      expression: "selectedResource"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "w-100 d-flex mt-2"
  }, [_c('button', {
    staticClass: "btn tertiary wide reset",
    on: {
      "click": function($event) {
        return _vm.renderFilters(_vm.getStoredEvents, true)
      }
    }
  }, [_vm._v("Clear All")])])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-2f167923", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f167923"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/calendar/Filters.vue
// module id = 1689
// module chunks = 0